<script setup lang="ts">
  import {
    computed, onBeforeUnmount, onMounted, ref
  } from 'vue'
  import type { IFlytTask } from '@/types/Flyt'

  import FocusHeader from '@/components/layout/FocusHeader.vue'
  import { KsCallout } from '@aschehoug/kloss'
  import { aschehougOidcClient } from '@/main'

  const props = defineProps<{
    element?: IFlytTask
    id?: string,
  }>()

  const flytContainerRef = ref<HTMLElement | null>(null)
  let cleanup: (() => void) | null = null
  const failedToLoad = ref(false)

  onBeforeUnmount(() => {
    cleanup?.()
  })

  const computedFlytId = computed(() => props.id || (props.element?.id || ''))

  onMounted(async () => {
    const el = flytContainerRef.value!

    // @ts-ignore Consult the Flyt team to decide on the best way to handle this
    const flytModule = await import('remote_app/flyt')
    cleanup = flytModule.default.mount(el as HTMLElement, {
      flytId: computedFlytId.value, // 'a0ce152b-48cd-4c6a-8c7a-f2dc1f00d108',
      theme: 'vgs',
      getAuthToken: () => aschehougOidcClient.getAccessToken(),
      endpoint: import.meta.env.VITE_FLYT_ENGINE,
      callbacks: {
        onErrorCaptured(e: Error) {
          console.error(e)
          failedToLoad.value = true
        }
      },
    })
  })


</script>

<template>
  <FocusHeader />
  <main class="flyt-task">
    <div class="flyt-container">
      <div
        v-if="!failedToLoad"
        ref="flytContainerRef"
      />
      <KsCallout v-else variant="error">
        Noe gikk galt ved innlasting av oppgaven. Prøv igjen!
      </KsCallout>
    </div>
  </main>
</template>

<style scoped lang="scss">
  .flyt-task {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px 1em;
    overflow: auto;
    background: var(--color-violet-10);
  }

  .flyt-container {
    width: 100%;
    max-width: 680px;
  }
</style>
